import React from 'react'

const Slide5 = () => {
  return (
    <div>
        <p>
        このゲームでは人生ゲームのようにマスを進めて単語をゲットします。<br></br>
        1~3の中から1つ数字を選び、その数だけ進む事ができます。<br></br>
        次に数字を選択する時同じ数字を使うことはできません
        </p>
    </div>
  )
}

export default Slide5